import {
  Component,
  Input,
  QueryList,
  ViewChildren,
  OnInit,
} from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import {
  PlantHandlingInstructionsFormComponent,
  PlantHandlingCopyArgs,
  DisplayOption,
  PlantHandlingOptions,
  PesticideDisplayOption,
} from "./plant-handling-instructions-form/plant-handling-instructions-form.component";
import { asEnumerable, Enumerable } from "linq-es2015";
import { CeRequestOptions } from "../../request-header/request-header.component";

@Component({
  selector: "app-plant-handling-instructions",
  templateUrl: "./plant-handling-instructions.component.html",
})
export class PlantHandlingInstructionsComponent implements OnInit {
  @Input() ceRequestOptions: CeRequestOptions;
  @Input() experimentDesignFormGroup: FormGroup;

  public get treatments(): FormArray {
    return <FormArray>this.experimentDesignFormGroup.get("treatments");
  }

  public plantHandlingOptions: PlantHandlingOptions;

  get plantHandlingInstructions(): FormGroup {
    return this.experimentDesignFormGroup.get(
      "plantHandlingInstructions"
    ) as FormGroup;
  }
  get pesticidesAllowed() {
    return this.experimentDesignFormGroup.get("pesticidesAllowed");
  }

  get pesticidesAllowedAfterDays() {
    return this.experimentDesignFormGroup.get("pesticidesAllowedAfterDays");
  }

  get pesticideLifeOfPlant() {
    return this.experimentDesignFormGroup.get("pesticideLifeOfPlant");
  }

  requiresNumberOfDays(): boolean {
    if (
      !this.pesticidesAllowed ||
      !this.plantHandlingOptions.pesticideInstructions
    ) {
      return false;
    }
    const id = this.pesticidesAllowed.value;
    return !!this.plantHandlingOptions.pesticideInstructions.find(
      (i) => i.id === id && i.requiresNumberOfDays
    );
  }

  ngOnInit() {
    const lightingInstructions = this.sortListByCeFlagAlphabetic(
      asEnumerable(this.ceRequestOptions.lightingInstructions)
    );

    const humidityInstructions = this.sortListByCeFlagAlphabetic(
      asEnumerable(this.ceRequestOptions.humidityInstructions)
    );

    const temperatureInstructions = this.sortListByCeFlagAlphabetic(
      asEnumerable(this.ceRequestOptions.temperatureInstructions)
    );

    const pesticideInstructions = this.sortPesticidesByOrderNumber(
      asEnumerable(this.ceRequestOptions.pesticideInstructions)
    );

    this.plantHandlingOptions = {
      lightingInstructions: lightingInstructions,
      humidityInstructions: humidityInstructions,
      temperatureInstructions: temperatureInstructions,
      pesticideInstructions: pesticideInstructions,
    };
  }

  @ViewChildren(PlantHandlingInstructionsFormComponent)
  public plantHandlingForms: QueryList<PlantHandlingInstructionsFormComponent>;

  public applyAll(
    sourceComponent: PlantHandlingInstructionsFormComponent
  ): void {
    const args: PlantHandlingCopyArgs = {
      lighting: sourceComponent.lighting.value,
      temperature: sourceComponent.temperature.value,
      humidity: sourceComponent.humidity.value,
      imagingNeeded: sourceComponent.imagingNeeded.value
    };

    this.plantHandlingForms.forEach((f) => f.copyValueFrom(args));
  }

  private sortListByCeFlagAlphabetic(
    list: Enumerable<Instruction>
  ): Array<DisplayOption> {
    return list
      .Where((s) => s.isActive)
      .OrderBy((s) => s.requiresFollowup)
      .ThenBy((s) => s.name)
      .Select((s) => {
        return <DisplayOption>{
          id: s.id,
          display: s.name,
        };
      })
      .ToArray();
  }

  private sortPesticidesByOrderNumber(
    list: Enumerable<PesticideInstruction>
  ): Array<PesticideDisplayOption> {
    return list
      .Where((s) => s.isActive && s.id !== 2)
      .OrderBy((s) => s.orderNumber)
      .Select((s) => {
        return <PesticideDisplayOption>{
          id: s.id,
          display: s.name,
          requiresNumberOfDays: s.requiresNumberOfDays,
        };
      })
      .ToArray();
  }
}

interface Instruction {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}

interface PesticideInstruction extends Instruction {
  orderNumber: number;
  requiresNumberOfDays: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions.component.ts